import { useSelector } from 'react-redux'
import { CurrencyType } from 'features/Programs/Shared/types'
import { AppState } from 'redux/config/store'
import { formatDashboardMoney } from './dashboardSummary'

export const useDashboardMoney = () => {
  const worksiteCurrency = useSelector(
    (state: AppState) => state.employeePlatform.profileData?.worksiteCurrency
  )
  const conversionRates = useSelector(
    (state: AppState) => state.application?.properties
  )
  const currency = (worksiteCurrency as CurrencyType) || 'USD'

  return (cents: number, decimals = 2) =>
    formatDashboardMoney(cents, currency, conversionRates ?? {}, decimals)
}
